/**
 * Facts the public (signed-out) pages state about the service.
 *
 * The service area is product copy, not a live lookup: GET /api/supported-states
 * needs a session, and the landing page must say where we operate before
 * anyone signs in. Keep it in step with Admin → Supported states.
 */

/** States where cutthe6.com is live today. */
export const SERVICE_STATES = [{ code: 'WI', name: 'Wisconsin' }];

/** "Wisconsin" (or "Wisconsin and Minnesota", ...), for copy. */
export const SERVICE_AREA_LABEL = SERVICE_STATES.map((state) => state.name).join(' and ');

/**
 * Support contact shown in the public footer. The Terms of Service seed text
 * names the same address (still marked "[confirm mailbox exists]").
 */
export const SUPPORT_EMAIL = 'support@cutthe6.com';

/** 50 states + DC, for the waitlist picker. */
export const US_STATES = [
  ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'],
  ['CA', 'California'], ['CO', 'Colorado'], ['CT', 'Connecticut'], ['DE', 'Delaware'],
  ['DC', 'District of Columbia'], ['FL', 'Florida'], ['GA', 'Georgia'], ['HI', 'Hawaii'],
  ['ID', 'Idaho'], ['IL', 'Illinois'], ['IN', 'Indiana'], ['IA', 'Iowa'],
  ['KS', 'Kansas'], ['KY', 'Kentucky'], ['LA', 'Louisiana'], ['ME', 'Maine'],
  ['MD', 'Maryland'], ['MA', 'Massachusetts'], ['MI', 'Michigan'], ['MN', 'Minnesota'],
  ['MS', 'Mississippi'], ['MO', 'Missouri'], ['MT', 'Montana'], ['NE', 'Nebraska'],
  ['NV', 'Nevada'], ['NH', 'New Hampshire'], ['NJ', 'New Jersey'], ['NM', 'New Mexico'],
  ['NY', 'New York'], ['NC', 'North Carolina'], ['ND', 'North Dakota'], ['OH', 'Ohio'],
  ['OK', 'Oklahoma'], ['OR', 'Oregon'], ['PA', 'Pennsylvania'], ['RI', 'Rhode Island'],
  ['SC', 'South Carolina'], ['SD', 'South Dakota'], ['TN', 'Tennessee'], ['TX', 'Texas'],
  ['UT', 'Utah'], ['VT', 'Vermont'], ['VA', 'Virginia'], ['WA', 'Washington'],
  ['WV', 'West Virginia'], ['WI', 'Wisconsin'], ['WY', 'Wyoming'],
];

/** States a visitor can join the waitlist for (everywhere we are not live). */
export const WAITLIST_STATES = US_STATES.filter(
  ([code]) => !SERVICE_STATES.some((state) => state.code === code),
);

/**
 * Set the document title and the description / Open Graph tags for a public
 * page. Social crawlers don't run JavaScript (nginx serves them a pre-rendered
 * preview of /homes/:id instead); this keeps the browser tab, bookmarks and
 * JS-rendering search crawlers in step with the page.
 *
 * @param {{title: string, description?: string, url?: string, image?: string}} meta
 */
export function setPublicPageMeta({ title, description, url, image }) {
  if (typeof document === 'undefined') return;
  if (title) document.title = title;
  const upsert = (attr, key, value) => {
    if (!value) return;
    let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute(attr, key);
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', value);
  };
  upsert('name', 'description', description);
  upsert('property', 'og:title', title);
  upsert('property', 'og:description', description);
  upsert('property', 'og:url', url);
  upsert('property', 'og:image', image);
}

/** The site-wide default title (public/index.html). */
export const DEFAULT_PAGE_TITLE = 'cutthe6.com';
